<template>
  <div class="content">
    <div id="episodes" class="carousel">
      <div v-if="items" class="movie carousel__container">
        <div
          v-for="item in items.episodes"
          :key="item.id"
          class="carousel-item movie--item"
          @click="seeDetail(item)"
        >
          <figure class="movie--img--item">
            <div v-if="item.imageUrl" v-lazy-container="{ selector: 'img' }">
              <img
                class="movie--img--item"
                :data-src="item.imageUrl"
                :alt="item.title"
              />
            </div>
            <div
              v-else-if="show.imageUrl != null"
              v-lazy-container="{ selector: 'img' }"
            >
              <img
                class="movie--img--item"
                :data-src="show.imageUrl"
                :alt="item.title"
              />
            </div>
            <div class="movie--no-img--item" v-else>
              <img class="movie-no-img" src="/img/no_image.png" />
            </div>
          </figure>
          <div class="detail_episode">
            <h5>{{ item.name }}</h5>
            <p>
              {{ item.description | truncate_140 }} <strong>View More</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
    <button class="icon-carousel icon-prev" @click="prev">
      <font-awesome-icon icon="chevron-left" />
    </button>
    <button class="icon-carousel icon-next" @click="next">
      <font-awesome-icon icon="chevron-right" />
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["showDetail", "show", "episodesModal"]),
  props: {
    items: { type: Object }
  },
  data() {
    return {};
  },
  watch: {
    items() {
      document
        .getElementById("episodes")
        .scroll({ left: 0, behavior: "smooth" });
    }
  },
  methods: {
    seeDetail(item) {
      if (!item.imageUrl) item.imageUrl = this.show.imageUrl;
      this.$store.commit("TOGGLE_EPISODES_MODAL", item);
    },
    prev: function() {
      let a = document.getElementById("episodes").scrollLeft;
      a -= 600;
      document
        .getElementById("episodes")
        .scroll({ left: a, behavior: "smooth" });
    },
    next: function() {
      let a = document.getElementById("episodes").scrollLeft;
      a += 600;
      document
        .getElementById("episodes")
        .scroll({ left: a, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.content {
  position: relative;
}
.movie {
  margin-top: 20px;
}
.movie--item {
  width: 30%;
  height: 300px;
  /* cursor: pointer; */
}

.movie--img {
  background-color: #738092;
  margin: 0px auto;
  width: 160px;
  height: 240px;
  vertical-align: top;
  border-radius: 10px;
}

.movie--img--item {
  /* background-color: #D5D5D5; */
  padding: 0px;
  margin: 0px;
  width: 100%;
  max-height: 150px;
  border-radius: 10px;
  object-fit: cover;
}
.movie--no-img--item {
  background-color: #d5d5d5;
  padding: 0px;
  margin: 0px;
  width: 100%;
  max-height: 150px;
  border-radius: 10px;
  object-fit: cover;
}

.movie-no-img {
  border-radius: 10px;
  width: 30%;
  max-height: 150px;
  object-fit: contain;
  margin: 10% 35%;
}

.detail_episode {
  margin: 10px;
}
.detail_episode > h5 {
  margin: 10px 0;
}
.detail_episode > p {
  white-space: initial;
  font-size: 0.75rem;
  line-height: 1.5;
  text-align: justify;
}

/* CAROUSEL */
.carousel {
  overflow-x: scroll;
  width: 100%;
}

.carousel__container {
  transition: 450ms -webkit-transform;
  transition: 450ms transform;
  transition: 450ms transform, 450ms -webkit-transform;
  font-size: 0;
  white-space: nowrap;
  padding-bottom: 10px;
  margin-top: 15px;
}

.carousel__container:hover .carousel-item:hover {
  -webkit-transform: scale(1.01);
  transform: scale(1.01);
  opacity: 1;
}

.carousel-item {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.carousel-item:hover ~ .carousel-item {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

.carousel-item__img {
  width: 95px;
  -o-object-fit: cover;
  object-fit: cover;
}

::-webkit-scrollbar {
  display: none;
}

.icon-carousel {
  background: rgba(0, 0, 0, 0);
  color: rgba(0, 0, 0, 0);
  border: 0px solid #9e9e9e;
  padding: 5px;
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  bottom: 10px;
  height: 300px;
  width: 40px;
}
.icon-carousel:hover {
  background: rgba(0, 0, 0, 0.9);
  color: white;
}

.icon-prev {
  left: 0px;
}

.icon-next {
  right: 0px;
}
/* FIN CAROUSEL */

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1024px) and (max-width: 1264px) {
}
@media (min-width: 1020px) and (max-width: 1024px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}

@media (max-width: 600px) {
  .movie--item {
    width: 70%;
    height: 300px;
  }
}
</style>

<style>
.btn_readmore {
  color: #4caf50;
}
</style>
